(function () {
  var CFG = window.BBB_CART_PRIO_CONFIG;
  if (!CFG) return;

  var MOUNT_ID = 'bbb-cart-prio-mount';
  var requestInFlight = false;
  var optimisticOn = null;

  function findMount() {
    return document.getElementById(MOUNT_ID);
  }

  function ensureMount() {
    var mount = findMount();
    if (mount) return mount;
    var footer =
      document.querySelector('#slidecarthq footer.footer') ||
      document.querySelector('#slidecarthq footer') ||
      document.querySelector('#slidecarthq .footer');
    if (!footer || !footer.parentNode) return null;
    mount = document.createElement('div');
    mount.id = MOUNT_ID;
    footer.parentNode.insertBefore(mount, footer);
    return mount;
  }

  function findLine(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(CFG.variantId)) return cart.items[i];
    }
    return null;
  }

  function getCart() {
    if (typeof window.SLIDECART_STATE === 'function') {
      try {
        var st = window.SLIDECART_STATE();
        if (st && st.cart) return Promise.resolve(st.cart);
      } catch (e) {}
    }
    return fetch('/cart.js').then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  function setToggleOn(toggle, isOn) {
    if (!toggle) return;
    if (isOn) toggle.classList.add('is-on');
    else toggle.classList.remove('is-on');
    toggle.setAttribute('aria-checked', isOn ? 'true' : 'false');
  }

  /** Subtitle by German local time: before 14:00 = heute, from 14:00 = morgen */
  function getPrioSubtitle() {
    var hourStr = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      hour: 'numeric',
      hourCycle: 'h23'
    }).format(new Date());
    var hour = parseInt(hourStr, 10);
    if (hour < 14) return 'Garantierter Versand noch heute';
    return 'Garantier Versand morgen';
  }

  function render(cart) {
    var mount = ensureMount();
    if (!mount || !document.getElementById('slidecarthq')) return false;

    var line = findLine(cart);
    var on = optimisticOn !== null ? optimisticOn : !!line;
    var img = CFG.image || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;

    mount.innerHTML =
      '<div class="bbb-cart-prio' +
      (requestInFlight ? ' is-loading' : '') +
      '" data-bbb-cart-prio data-variant-id="' +
      CFG.variantId +
      '" data-line-key="' +
      (line && line.key ? line.key : '') +
      '"><div class="bbb-cart-prio__inner"><div class="bbb-cart-prio__left">' +
      '<div class="bbb-cart-prio__icon">' +
      (img
        ? '<img class="bbb-cart-prio__icon-img" src="' + img + '" width="21" height="21" alt="">'
        : '') +
      '</div><div class="bbb-cart-prio__content">' +
      '<p class="bbb-cart-prio__title"></p><p class="bbb-cart-prio__subtitle"></p>' +
      '</div></div><div class="bbb-cart-prio__right"><span class="bbb-cart-prio__price"></span>' +
      '<button type="button" class="bbb-cart-prio__toggle' +
      (on ? ' is-on' : '') +
      '" role="switch" aria-checked="' +
      (on ? 'true' : 'false') +
      '" aria-label="' +
      String(CFG.title).replace(/"/g, '&quot;') +
      '"><span class="bbb-cart-prio__toggle-track" aria-hidden="true"><span class="bbb-cart-prio__toggle-knob"></span></span></button>' +
      '</div></div></div>';

    mount.querySelector('.bbb-cart-prio__title').textContent = CFG.title;
    var subEl = mount.querySelector('.bbb-cart-prio__subtitle');
    console.log('subEl', subEl);
    subEl.textContent = getPrioSubtitle();
    mount.querySelector('.bbb-cart-prio__price').textContent = CFG.price;

    var block = mount.querySelector('[data-bbb-cart-prio]');
    var toggle = mount.querySelector('.bbb-cart-prio__toggle');

    if (toggle && toggle.getAttribute('data-bound') !== 'true') {
      toggle.setAttribute('data-bound', 'true');
      if (requestInFlight) toggle.disabled = true;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (requestInFlight || block.classList.contains('is-loading') || toggle.disabled) return;

        var turningOn = !toggle.classList.contains('is-on');
        var prevKey = block.getAttribute('data-line-key') || '';

        requestInFlight = true;
        optimisticOn = turningOn;
        setToggleOn(toggle, turningOn);
        block.classList.add('is-loading');
        toggle.disabled = true;

        var req = turningOn
          ? cartRequest('/cart/add.js', { id: CFG.variantId, quantity: 1 })
          : cartRequest('/cart/change.js', {
              id: prevKey || CFG.variantId,
              quantity: 0
            });
        req
          .then(function (data) {
            if (turningOn && data) {
              var added =
                data.key || (data.items && data.items[0] && data.items[0].key) || '';
              if (added) block.setAttribute('data-line-key', added);
              else if (data.items) {
                var found = findLine(data);
                if (found && found.key) block.setAttribute('data-line-key', found.key);
              }
            }
            if (!turningOn) block.setAttribute('data-line-key', '');
            requestInFlight = false;
            optimisticOn = null;
            block.classList.remove('is-loading');
            toggle.disabled = false;
            if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE(refresh);
            } else {
              refresh();
            }
          })
          .catch(function (err) {
            console.error('[bbb-cart-prio]', err);
            requestInFlight = false;
            optimisticOn = null;
            setToggleOn(toggle, !turningOn);
            block.setAttribute('data-line-key', prevKey);
            block.classList.remove('is-loading');
            toggle.disabled = false;
          });
      });
    }
    return true;
  }

  function refresh() {
    if (requestInFlight) return;
    getCart()
      .then(render)
      .catch(function () {
        render(null);
      });
  }

  function wrap(name) {
    var prev = window[name];
    if (prev && prev.__bbbPrio) return;
    var wrapped = function () {
      if (typeof prev === 'function' && !prev.__bbbPrio) {
        try {
          prev.apply(this, arguments);
        } catch (e) {}
      }
      setTimeout(refresh, 0);
      setTimeout(refresh, 100);
      setTimeout(refresh, 400);
    };
    wrapped.__bbbPrio = true;
    window[name] = wrapped;
  }

  function start() {
    wrap('SLIDECART_LOADED');
    wrap('SLIDECART_UPDATED');
    wrap('SLIDECART_OPENED');
    refresh();
    new MutationObserver(function () {
      var mount = findMount();
      if (document.getElementById('slidecarthq') && (!mount || !mount.querySelector('[data-bbb-cart-prio]'))) {
        refresh();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    setInterval(function () {
      wrap('SLIDECART_LOADED');
      wrap('SLIDECART_UPDATED');
      wrap('SLIDECART_OPENED');
      var mount = findMount();
      if (document.getElementById('slidecarthq') && (!mount || !mount.querySelector('[data-bbb-cart-prio]'))) {
        refresh();
      }
    }, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
